import api from './api';

// 백엔드 기본 URL 설정 (환경 변수 또는 직접 입력)
// api.js의 baseURL을 사용하거나 직접 지정
// const BASE_URL = 'https://port-0-bemaster-mild533144fe3281.sel3.cloudtype.app'; 

// 1. 채팅방 목록 조회
export const getChatRooms = async () => {
    try {
        const response = await api.get('/api/chats/rooms');
        return response.data;
    } catch (error) {
        console.error('채팅방 목록 가져오기 실패:', error);
        throw error;
    }
};

// 2. 채팅방 생성 (이미지 포함)
export const createChatRoom = async (roomData, file) => {
    try {
        const formData = new FormData();

        // request part: JSON
        const blob = new Blob([JSON.stringify(roomData)], { type: 'application/json' });
        formData.append('request', blob);

        // file part
        if (file) {
            formData.append('file', file);
        }

        const response = await api.post('/api/chats/rooms', formData);
        return response.data;
    } catch (error) {
        console.error('채팅방 생성 실패:', error);
        throw error;
    }
};

// 3. 채팅 내역 조회 (입장 시 사용)
export const getChatHistory = async (chatRoomId) => {
    try {
        const response = await api.get(`/api/chats/${chatRoomId}`);
        return response.data;
    } catch (error) {
        console.error('채팅 내역 가져오기 실패:', error);
        throw error;
    }
};

// 4. 초대 링크 생성
export const createInviteLink = async (chatRoomId) => {
    try {
        const response = await api.post(`/api/chats/rooms/${chatRoomId}/invite-link`);
        return response.data; // { roomId, inviteCode, inviteUrl }
    } catch (error) {
        console.error('초대 링크 생성 실패:', error);
        throw error;
    }
};

// 5. 초대 코드로 입장
export const joinChatRoom = async (roomId, inviteCode) => {
    try {
        const response = await api.post(`/api/chats/rooms/${roomId}/join`, { inviteCode });
        return response.data;
    } catch (error) {
        console.error('초대 코드로 입장 실패:', error);
        throw error;
    }
};

// 6. 멤버 추가 (ID/닉네임 등)
export const addMember = async (chatRoomId, identifier) => {
    try {
        // 기존 POST /api/chats/rooms/{roomId}/members
        const response = await api.post(`/api/chats/rooms/${chatRoomId}/members`, { identifier });
        return response.data;
    } catch (error) {
        console.error('멤버 추가 실패:', error);
        throw error;
    }
};

// 7. 사용자 검색
// 7. 사용자 검색 (채팅방 초대용)
export const searchUser = async (identifier) => {
    try {
        // Spec: GET /api/chats/users/search?identifier=...
        const response = await api.get(`/api/chats/users/search`, { params: { identifier } });
        return response.data; // { userId, displayName, username }
    } catch (error) {
        console.error('사용자 검색 실패:', error);
        throw error;
    }
};

// 8. 멤버 목록/수 조회
export const getChatRoomMembers = async (chatRoomId) => {
    try {
        const response = await api.get(`/api/chats/rooms/${chatRoomId}/members`);
        return response.data; // { roomId, memberCount, members: [...] }
    } catch (error) {
        console.error('멤버 목록 조회 실패:', error);
        throw error;
    }
};

// 9. 방 폭파 (삭제)
export const deleteChatRoom = async (chatRoomId) => {
    try {
        await api.delete(`/api/chats/rooms/${chatRoomId}`);
    } catch (error) {
        console.error('채팅방 삭제 실패:', error);
        throw error;
    }
};
// 10. 채팅방 이미지 업로드
export const uploadChatImage = async (chatRoomId, file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await api.post(`/api/chats/rooms/${chatRoomId}/images`, formData);
        return response.data; // { imageUrl: "..." }
    } catch (error) {
        console.error('이미지 업로드 실패:', error);
        throw error;
    }
};

// 11. 투표 생성
export const createPoll = async (chatRoomId, question, options) => {
    try {
        const response = await api.post(`/api/chats/rooms/${chatRoomId}/polls`, { question, options });
        return response.data;
    } catch (error) {
        console.error('투표 생성 실패:', error);
        throw error;
    }
};

// 12. 투표 상세 조회
export const getPollDetails = async (pollId) => {
    try {
        const response = await api.get(`/api/chats/polls/${pollId}`);
        return response.data;
    } catch (error) {
        console.error('투표 상세 조회 실패:', error);
        throw error;
    }
};

// 13. 투표하기
export const votePoll = async (pollId, optionId) => {
    try {
        const response = await api.post(`/api/chats/polls/${pollId}/votes`, { optionId });
        return response.data;
    } catch (error) {
        console.error('투표하기 실패:', error);
        throw error;
    }
};

// 13-1. 투표 종료 (생성자 전용)
export const closePoll = async (pollId) => {
    try {
        const response = await api.post(`/api/chats/polls/${pollId}/close`);
        return response.data;
    } catch (error) {
        console.error('투표 종료 실패:', error);
        throw error;
    }
};

// 14. 공지 목록 조회 (최신순)
export const getChatRoomNotices = async (chatRoomId) => {
    try {
        const response = await api.get(`/api/chats/rooms/${chatRoomId}/notices`);
        return response.data;
    } catch (error) {
        console.error('공지 목록 조회 실패:', error);
        throw error;
    }
};

// 15. 투표를 공지로 등록
export const createPollNotice = async (chatRoomId, pollId, message) => {
    try {
        const response = await api.post(`/api/chats/rooms/${chatRoomId}/notices/polls`, {
            pollId,
            message,
        });
        return response.data;
    } catch (error) {
        console.error('투표 공지 등록 실패:', error);
        throw error;
    }
};
// 16. 채팅방 목록 요약 조회 (Unread Count 포함)
export const fetchChatRoomsSummary = async () => {
    try {
        const response = await api.get('/api/chats/rooms/summary');
        return response.data; // [{ roomId, name, unreadCount, ... }, ...]
    } catch (error) {
        console.error('채팅방 요약 조회 실패:', error);
        throw error;
    }
};

// 17. 채팅방 읽음 처리
export const markRoomAsRead = async (roomId) => {
    try {
        await api.post(`/api/chats/rooms/${roomId}/read`);
    } catch (error) {
        console.error('채팅방 읽음 처리 실패:', error);
        throw error;
    }
};

// 18. 통합 검색 (채팅방 + 메시지 요약)
export const searchChatAll = async (keyword) => {
    try {
        const response = await api.get('/api/chats/search', { params: { keyword } });
        return response.data; // { rooms: [], messages: [] }
    } catch (error) {
        console.error('통합 검색 실패:', error);
        throw error;
    }
};

// 19. 채팅방 검색 (더보기)
export const searchChatRooms = async (keyword, limit = 20) => {
    try {
        const response = await api.get('/api/chats/search/rooms', { params: { keyword, limit } });
        return response.data; // ChatRoomSearchResponse[]
    } catch (error) {
        console.error('채팅방 검색 실패:', error);
        throw error;
    }
};

// 20. 메시지 검색 (더보기)
export const searchChatMessages = async (keyword, page = 0, size = 20) => {
    try {
        const response = await api.get('/api/chats/search/messages', { params: { keyword, page, size } });
        return response.data; // ChatMessageSearchResponse[]
    } catch (error) {
        console.error('메시지 검색 실패:', error);
        throw error;
    }
};

// 21. 특정 채팅방 마지막 메시지 1건 조회
export const getLastChatMessage = async (roomId) => {
    try {
        const response = await api.get(`/api/chats/rooms/${roomId}/messages/last`);
        return response.data;
    } catch (error) {
        // 마지막 메시지가 아직 없는 방(404 등)일 수 있어 호출부에서 조용히 처리할 수 있게 원본 에러를 유지
        console.error('마지막 메시지 조회 실패:', error);
        throw error;
    }
};
